module.exports = __webpack_public_path__ + "static/media/DESTINATION-WEDDINGS-IN-PORTUGAL-BATHROOM-OF-SUPERIOR-LUXURY-SEA-VIEW-ROOM.b88241ba.jpg";